export default {
    individual: 'Individual',
    createMessage: 'Create Message',
    startDate: 'Start Date',
    endDate: 'End Date',
    topic: 'Topic',
    employeeNo: 'Employee No',
    employeeName: 'Full Name',
    searchByTopicOrEmployeeNo: 'Search By Topic Or Employee No',
    search: 'Search',
    deleteMessage: 'Delete Message',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Message individual is deleted.',
    questionDelete: 'Are you sure to delete "$Name"?'
}
